import { useMutation } from 'react-query';
import { api } from 'services/api';

type PaymentProps = {
  card: {
    /**
     * Credit card number
     */
    number: string;
    /**
     * Credit card holder name
     */
    holder_name: string;
    /**
     * Credit card expiration month
     */
    expiration_month: number;
    /**
     * Credit card expiration year '22'
     */
    expiration_year: number;
    /**
     * Credit card security code (CVV)
     */
    security_code: string;
  };
};

type UseCreatePaymentParamsProps = {
  /**
   * Unit identificator.
   */
  unit_id: string;
  /**
   * User's name
   */
  name?: string;
  /**
   * User's mobile phone
   */
  mobile?: string;
  /**
   * User's e-mail
   */
  email?: string;

  /**
   * People quantity
   */
  people: number;
  /**
   * User's payment data
   */
  payment_data?: PaymentProps;
};

export type LoginResponse = {
  access_token: string;
};

type CreatePaymentProps = {
  status: number;
  data: LoginResponse;
};

export const createPayment = async (
  params: UseCreatePaymentParamsProps
): Promise<CreatePaymentProps> => {
  const { status, data } = await api.post(
    `/line/v1/units/${params.unit_id}/lines`,
    params
  );

  return {
    status,
    data: {
      ...data.data,
    },
  };
};

export const useCreatePayment = () => {
  return useMutation('create-payment', (params: UseCreatePaymentParamsProps) =>
    createPayment(params)
  );
};
